export const copiedDocumentNameTextsPath = 'components.legalTermsDropdown';
export const buildCopyName = (name, count, texts)=>texts.copiedDocumentName({
        name,
        count
    });
const normalize = (value)=>value.trim().toLowerCase();
const copyIndexOf = (existing, name, texts)=>{
    const trailingNumber = existing.match(/\((\d+)\)\s*$/);
    const index = trailingNumber != null ? Number(trailingNumber[1]) : 1;
    return normalize(buildCopyName(name, index, texts)) === existing ? index : null;
};
export const generateUniqueCopyName = function generateUniqueCopyName(name, existingNames, texts) {
    let startCount = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    const highestUsed = existingNames.reduce((highest, existing)=>{
        const index = copyIndexOf(normalize(existing), name, texts);
        return index != null && index > highest ? index : highest;
    }, 0);
    return buildCopyName(name, Math.max(highestUsed + 1, startCount, 1), texts);
};
